import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { ICurrencyConfig, IPartnerConfig } from "src/constants/interfaces";
import { IFreeBet, ISelection } from "src/constants/interfaces/bet";
import { permutation } from "../helpers";
import { getTaxedStake } from "../tax";
import { getMultiplePossibleWin } from "./multiple";
import { getSinglePossibleWin } from "./single";
import { getSystemPossibleWin } from "./system";
import { getPrice } from "../priceCalculation";

const calcPossibleWin = {
  [BetTypeEnum.Single]: getSinglePossibleWin,
  [BetTypeEnum.Multiple]: getMultiplePossibleWin,
  [BetTypeEnum.System]: getSystemPossibleWin,
  [BetTypeEnum.Chain]: null,
  [BetTypeEnum.StraightForecast]: null,
  [BetTypeEnum.StraightTricast]: null,
  [BetTypeEnum.ReverseForecast]: null,
  [BetTypeEnum.CombinationForecast]: null,
  [BetTypeEnum.CombinationTricast]: null,
};

export const getSystemMinPossibleWin = (
  stake: number,
  selections: ISelection[],
  systemCombinationCount: number,
  partnerConfig: IPartnerConfig | undefined,
  currencyConfig?: ICurrencyConfig,
) => {
  const bankers = selections.filter(item => item.isBanker);
  const remainSelections = selections.filter(item => !item.isBanker);
  const remainCombinationCount = systemCombinationCount - bankers.length;

  let result = bankers.reduce((acc, item) => acc * getPrice(item), 1);
  const taxedStake = getTaxedStake(partnerConfig, stake, currencyConfig);

  remainSelections
    .map(getPrice)
    .sort((a, b) => a - b)
    .slice(0, remainCombinationCount)
    .forEach(price => (result *= price));

  return taxedStake * (result / permutation(remainSelections.length, remainCombinationCount));
};

export const getPossibleWin = (
  config: IClientConfig,
  betType: BetTypeEnum,
  stake: number,
  selections: ISelection[],
  systemCombinationCount?: number,
  partnerConfig?: IPartnerConfig,
  selectedFreeBet?: IFreeBet,
  currencyConfig?: ICurrencyConfig,
) => {
  if (!stake || !selections.length) return null;

  const freeBetAmount = selectedFreeBet?.details.amount || 0

  const taxedStake = getTaxedStake(partnerConfig, stake, currencyConfig);

  const possibleWin = calcPossibleWin[betType]?.(
    config,
    taxedStake,
    selections,
    systemCombinationCount || 0,
    partnerConfig
  )

  if (possibleWin) return possibleWin - freeBetAmount

  return possibleWin ?? null
};